import React from "react"
// eslint-disable-next-line no-restricted-imports -- TODO move to @mallardbay/lib-react-components
import type { TextareaProps } from "@chakra-ui/react"
// eslint-disable-next-line no-restricted-imports -- TODO move to @mallardbay/lib-react-components
import { InputGroup, Textarea, useTheme } from "@chakra-ui/react"
import { useController, useFormContext } from "react-hook-form"
import type { CustomTheme } from "@mallardbay/lib-react-components"

import HookFormControl from "~components/shared/hook-form/core/hook-form-control"

interface Props extends TextareaProps {
    readonly name: string
    readonly label?: string
}

export default function TextAreaControl({ name, label, ...inputProps }: Props) {
    const { control } = useFormContext()

    const {
        field: { name: fieldName, value, onChange, onBlur },
    } = useController({ control, name })

    const styles = useStyles()

    return (
        <HookFormControl
            label={label}
            name={fieldName}
            isRequired={inputProps.isRequired}
        >
            <InputGroup>
                <Textarea
                    {...inputProps}
                    rows={3}
                    aria-label={label}
                    name={fieldName}
                    value={value ?? ""}
                    onBlur={onBlur}
                    onChange={(event) => {
                        onChange(event.target.value)
                    }}
                    {...styles.input}
                />
            </InputGroup>
        </HookFormControl>
    )
}

function useStyles() {
    const { colors } = useTheme<CustomTheme>()

    const input: TextareaProps = {
        focusBorderColor: colors.brand[500],
    }

    return {
        input,
    }
}
